import type { ErrorComponentProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthLayout, Button, ErrorNotice } from "../components/form.js";

/** Shown when a route guard fails outright, typically because the API is unreachable. */
export function RouteErrorPage({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t("common.unavailableTitle")} subtitle={t("common.unavailableSubtitle")}>
      <div className="flex flex-col gap-4">
        <ErrorNotice error={error} />
        <Button onClick={() => reset()}>{t("common.retry")}</Button>
      </div>
    </AuthLayout>
  );
}
